// Module
var code = "<a href=\"{{dictionary_entry.href}}\" target=\"_blank\" class=\"route no-outline\"> <i class=\"material-icons right\">help_outline</i> </a> ";
// Exports
export default code;